var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MapFooterLandowners"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"allowfullscreen":"","height":"250","loading":"lazy","src":_vm.mapSrc,"title":"address-map","width":"300"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }